var exports = {
  "I2": "commentBody__e-JYdf",
  "xi": "commentContainer__ZnY8al",
  "yE": "commentContainerAnchorable__1V768y",
  "DH": "nestedReplyWrapper__t2C1j0",
  "_i": "nestedReplyLine__xa6S8r",
  "g$": "activityHeaderWrapper__WG4vIz",
  "Gp": "activityHeaderWrapperNotNested__9VfBDG",
  "lH": "replyContentWrapper__lrUG4r",
  "Pf": "replyContentWrapperReply__gPEuZq",
  "NY": "replyBorder__0fy2Fl",
  "Lp": "replyBorderLast__jTkGCL",
  "Yu": "contentReply___pV-AS",
  "JS": "contentNotReply__ofjaOs",
  "Or": "reactionsWrapper__tJFaQG",
};

module.exports = exports;
